const useMaximumScreenBrightness = (_shouldApply: boolean = true) => {};

export default useMaximumScreenBrightness;
